import {
    IonGrid, IonRow, IonCol
  } from "@ionic/react";
import { useEffect, useState } from "react";
import { getCookie, setCookie } from "../../../utils/cookie"

import { GlobalStore } from "../../../store/GlobalStore"

function PaymentSummary() {

  const {
    getDeliveryDetails
  }= GlobalStore()

  // const deliveryDetails = getDeliveryDetails()

  const deliveryDetails =  JSON.parse(sessionStorage.getItem("deliveryAddresses"))
  

  useEffect(()=>{
    let item_value = JSON.parse(sessionStorage.getItem("deliveryAddresses"))
    
  },[])

    return (
        <>
            <div className="summary payment">
                <IonGrid>
                  <IonRow>
                  {deliveryDetails && 
                      <>
                    <IonCol size="7">
                      <h5>Est Delivery Time</h5>
                      <h1>{Math.round(deliveryDetails.duration / 60)} mins</h1>
                      <p>Pickup Location</p>
                      <h4>{deliveryDetails.pickUpLocation.address}</h4>
                    </IonCol>
                    <IonCol size="5">
                      <h5>Total Fare</h5>
                      <h1>{`${deliveryDetails.currency} ${deliveryDetails.tripFare}`}</h1>
                      <p>
                        Inclusive of GST <br />
                        <b>Learn more</b> about our delivery charges
                      </p>
                      
                    </IonCol>
                    </>
                  }
                  </IonRow>
                </IonGrid>
              </div>
        </>
    )
}

export default PaymentSummary;